import React from 'react';

import '../../styles/loader.scss';

const RestrictedPageLoader = () => (
  <div
    className="page-not-found"
  >
    <img
      src="/img/zenyum-animated-loader.gif"
      alt="loader"
    />
  </div>
);

export default RestrictedPageLoader;
